// Design preview. Leave false so the screen reads real notifications.
export const showNotificationMocks = true
